var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.properties.label}},[_c('b-textarea',{attrs:{"rows":"15","size":"sm"},model:{value:(_vm.propertyValue),callback:function ($$v) {_vm.propertyValue=$$v},expression:"propertyValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }